import { useState, useRef, useEffect } from "react";
import "./PhoneInput.scss";

const DEFAULT_PREFIXES = [
  { code: "+421", iso: "sk", label: "SK" },
  { code: "+420", iso: "cz", label: "CZ" },
//   { code: "+48",  iso: "pl", label: "PL" },
//   { code: "+43",  iso: "at", label: "AT" },
//   { code: "+49",  iso: "de", label: "DE" },
];

/**
 * PhoneInput
 *
 * Props:
 *  - value        {string}   — číslo bez predvoľby
 *  - prefix       {string}   — aktuálna predvoľba, napr. "+421"
 *  - onChange     {fn}       — (number: string) => void
 *  - onPrefixChange {fn}     — (prefix: string) => void
 *  - prefixes     {array}    — voliteľný vlastný zoznam predvolieb
 *  - id           {string}
 *  - placeholder  {string}
 *  - required     {bool}
 */
function PhoneInput({
  value = "",
  prefix = "+421",
  onChange,
  onPrefixChange,
  prefixes = DEFAULT_PREFIXES,
  id = "phone-input",
  placeholder = "912 345 678",
  required = false,
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selected = prefixes.find((p) => p.code === prefix) ?? prefixes[0];

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="phone-input">
      <div className="phone-input__prefix-picker" ref={wrapperRef}>
        <button
          type="button"
          className="phone-input__prefix-btn"
          tabIndex={-1}
          onClick={() => setOpen((o) => !o)}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-label="Vybrať predvoľbu krajiny"
        >
          <img
            src={`https://flagcdn.com/w20/${selected.iso}.png`}
            srcSet={`https://flagcdn.com/w40/${selected.iso}.png 2x`}
            width="20"
            height="14"
            alt={selected.label}
            className="phone-input__flag"
          />
          <span className="phone-input__prefix-code">{selected.code}</span>
        </button>

        {open && (
          <ul className="phone-input__dropdown" role="listbox">
            {prefixes.map((p) => (
              <li
                key={p.code}
                role="option"
                aria-selected={p.code === prefix}
                className={`phone-input__option${
                  p.code === prefix ? " phone-input__option--active" : ""
                }`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onPrefixChange?.(p.code);
                  setOpen(false);
                }}
              >
                <img
                  src={`https://flagcdn.com/w20/${p.iso}.png`}
                  srcSet={`https://flagcdn.com/w40/${p.iso}.png 2x`}
                  width="20"
                  height="14"
                  alt={p.label}
                  className="phone-input__flag"
                />
                <span className="phone-input__prefix-code">{p.code}</span>
                <span className="phone-input__option-label">{p.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <span className="phone-input__sep" aria-hidden="true" />

      <input
        id={id}
        type="tel"
        className="phone-input__number"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        autoComplete="tel-national"
        inputMode="tel"
        required={required}
      />
    </div>
  );
}

export default PhoneInput;
